{
  "aboutFarmJoinCodes": "À propos des codes d'adhésion à la ferme",
  "back": "Dos",
  "codeExpired": "Code expiré",
  "codeExpiredErrorMessage": "Votre code d'adhésion à la ferme a expiré. Pour permettre à de nouveaux utilisateurs de rejoindre votre compte de ferme, vous devez créer un nouveau code.",
  "codeExpiresWithColon": "Le code expire :",
  "codeNotCreated": "Code non créé",
  "codeNotCreatedErrorMessage": "Vous devez créer un nouveau code de jonction de ferme pour permettre aux utilisateurs de rejoindre votre ferme.",
  "codeWithColon": "Code:",
  "copyCode": "Copie",
  "farmJoinCode": "Code d'adhésion à la ferme",
  "farmJoinCodeHelpSummary": "Les codes d'adhésion à la ferme sont des codes à 6 chiffres générés aléatoirement qui permettent aux nouveaux utilisateurs de rejoindre un compte de ferme. Lorsque l'utilisateur rejoint la ferme, il commence avec les autorisations spécifiées par la ferme.\n\nLes codes d'adhésion à la ferme expirent après une certaine période. Si vous créez un code et que celui-ci expire, vous devrez créer un nouveau code si vous souhaitez que de nouveaux utilisateurs puissent rejoindre votre ferme.",
  "farmJoinCodeNotCreatedMessage": "Vous devez créer un nouveau code de jonction de ferme pour permettre aux utilisateurs de rejoindre votre ferme.",
  "farmJoinCodeShareMessageWithActiveFarmNameAndCodeString": "Utilisez ce code de connexion à la ferme pour rejoindre la ferme {{activeFarmName}}\n{{codeString}}",
  "farmJoinCodeShareTitleWithActiveFarmName": "[FarmHQ] : Code d'adhésion pour {{activeFarmName}}",
  "farmJoinCodeStatus": {
    "ACTIVE": "Actif",
    "EXPIRED": "Expiré",
    "NOT_CREATED": "Non créé"
  },
  "farmJoinCodeTitle": "Code d'adhésion à la ferme",
  "newCode": "Nouveau code",
  "newFarmJoinCode": "Nouveau code d'adhésion à la ferme",
  "newFarmJoinCodeHelpSummary": "Lorsqu'un utilisateur rejoint votre ferme en saisissant un code de jonction de ferme, les autorisations spécifiées lors de la création de ce code lui sont attribuées. Les autorisations d'un utilisateur peuvent être modifiées ultérieurement par un administrateur de ferme.",
  "note": "Note: ",
  "shareCode": "Partager",
  "somethingWentWrong": "Quelque chose s'est mal passé",
  "unableToCopyCode": "Impossible de copier le code",
  "yourCode": "Votre code"
}
